<header
  class="header"
  [ngClass]="{
    'header--white': bgWhite,
    'header--hidden': hideHeader,
    'header--fixed': !hideHeader && lastScrollPosition > currentActionScroll && !isMenuOpen,
  }"
>
  <div class="header__container">
    <div class="h-full flex items-center gap-4">
      <!-- Burger Menu Button - Mobile -->

      <p-button
        icon="pi pi-bars"
        severity="contrast"
        size="large"
        rounded
        text
        (onClick)="toggleMenu()"
      />

      <!-- Logo -->
      <a class="header__logo" [routerLink]="['/']" routerLinkActive="router-link-active">
        <img [src]="'./icons/logo-d2d.svg'" [alt]="'Logo D2D'" />
      </a>
    </div>

    <!-- Menu - Desktop -->
    <nav class="header__navigation">
      @for (item of menu; track $index) {
        @if (item.type === 'link' && item.inDesk !== false) {
          <a
            [routerLink]="[item.url]"
            routerLinkActive="router-link-active"
            class="header__navigation-anchor"
            [ngClass]="{
              'header__navigation-anchorIcon': item.prev_icon,
            }"
          >
            @if (item.prev_icon) {
              <i [class]="item.prev_icon"></i>
            }
            {{ item.title | transloco }}</a
          >
        }
      }
    </nav>

    <div class="flex items-center gap-4">
      @if (purchaseWidgetService.isActive()) {
        <div class="cart-container hidden md:inline-flex">
          <span class="cart-radar-ring" aria-hidden="true"></span>
          <button
            type="button"
            pButton
            severity="secondary"
            rounded
            class="cart-header-btn"
            [class.cart-header-btn--wiggle]="purchaseWidgetService.isWiggling()"
            (click)="purchaseWidgetService.open()"
            aria-label="Carrito de compra"
          >
            <i class="pi pi-shopping-cart text-base sm:text-lg"></i>
          </button>
          @if (purchaseWidgetService.itemCount() > 0) {
            <p-badge
              [value]="purchaseWidgetService.itemCount().toString()"
              severity="danger"
              styleClass="!absolute -top-1 -right-1 z-10 cart-badge-bounce pointer-events-none"
            />
          }
        </div>
      }
      @if (sessionState() === 'loading') {
        <div class="flex items-center gap-2">
          <p-skeleton width="120px" height="40px" borderRadius="20px" />
        </div>
      } @else if (sessionState() === 'unauthenticated' && !authStore.isGuestFlow()) {
        <button
          pButton
          class="header__account"
          rounded
          size="large"
          (click)="goToLogin()"
          (keydown.enter)="goToLogin()"
        >
          <span>{{ 'header.loginButton' | transloco }}</span>
        </button>
      } @else if (sessionState() === 'unauthenticated' && authStore.isGuestFlow()) {
        <!-- Guest flow: botón de login oculto intencionalmente -->
      } @else {
        <div class="profile-item static sm:relative">
          <a
            pButton
            severity="secondary"
            rounded
            class="right-sidebar-button relative"
            pStyleClass="@next"
            enterFromClass="hidden"
            enterActiveClass="animate-scalein"
            leaveActiveClass="animate-fadeout"
            leaveToClass="hidden"
            [hideOnOutsideClick]="true"
          >
            <div class="flex flex-col max-w-36 ml-1 overflow-hidden text-left">
              <div
                class="font-semibold text-xs truncate"
                title="{{ account()?.first_name }} {{ account()?.last_name }}"
              >
                {{ account()?.first_name }} {{ account()?.last_name }}
              </div>
              @if (account()?.roles?.length) {
                <div
                  class="text-[10px] text-primary truncate leading-tight"
                  title="{{ account()?.roles?.[0]?.name }}"
                >
                  {{ account()?.roles?.[0]?.name }}
                </div>
              }
            </div>
            @if (account()?.photo_url) {
              <p-avatar styleClass="!w-10 !h-10 !rounded-full !bg-transparent !overflow-hidden">
                <img
                  [src]="account()!.photo_url"
                  [alt]="account()!.first_name + ' ' + account()!.last_name"
                  class="object-cover w-10 h-10"
                  (error)="showAvatar()"
                />
              </p-avatar>
            } @else {
              <p-avatar
                [label]="account()!.first_name![0] + account()!.last_name![0]"
                shape="circle"
                styleClass="!text-sm"
                size="large"
              />
            }
          </a>
          <div
            class="list-none p-2 m-0 rounded-2xl border border-surface overflow-hidden absolute bg-surface-0 dark:bg-surface-800/90 hidden origin-top w-52 mt-2 right-0 z-[999] top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
          >
            <ul class="flex flex-col gap-1 text-surface-700">
              @if (account()?.roles?.length && account()?.session_metadata?.has_internal_access) {
                <li>
                  <a
                    tabindex="0"
                    class="label-small text-primary-500 dark:primary-red-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-primary-500/10 transition-colors duration-150 cursor-pointer"
                    (click)="goToAdmin()"
                    (keydown.enter)="goToAdmin()"
                  >
                    <i class="pi pi-shield"></i>
                    <span>{{ 'header.profileMenu.internalArea' | transloco }}</span>
                  </a>
                </li>
              }
              <li>
                <a
                  class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                  [routerLink]="['/user/profile']"
                >
                  <i class="pi pi-user"></i>
                  <span>{{ 'header.profileMenu.myAccount' | transloco }}</span>
                </a>
              </li>
              <li>
                <a
                  class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                  [routerLink]="['/user/shipments']"
                >
                  <i class="pi pi-send"></i>
                  <span>{{ 'header.profileMenu.myShipments' | transloco }}</span>
                </a>
              </li>

              <li>
                <a
                  class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                  [routerLink]="['/user/incidents']"
                >
                  <i class="pi pi-ticket"></i>
                  <span>{{ 'header.profileMenu.myIncidents' | transloco }}</span>
                </a>
              </li>
              <li>
                <a
                  class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                  [routerLink]="['/user/addresses']"
                >
                  <i class="pi pi-globe"></i>
                  <span>{{ 'header.profileMenu.myAddresses' | transloco }}</span>
                </a>
              </li>
              <li>
                <a
                  class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                  [routerLink]="['/user/contacts']"
                >
                  <i class="pi pi-address-book"></i>
                  <span>{{ 'header.profileMenu.myContacts' | transloco }}</span>
                </a>
              </li>
              <li>
                <a
                  class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                  [routerLink]="['/user/settings']"
                >
                  <i class="pi pi-cog"></i>
                  <span>{{ 'header.profileMenu.settings' | transloco }}</span>
                </a>
              </li>
              <li>
                <a
                  class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                  [routerLink]="['/user/billing']"
                >
                  <i class="pi pi-file"></i>
                  <span>{{ 'header.profileMenu.myInvoices' | transloco }}</span>
                </a>
              </li>
              <hr />
              @if (hasAccounts) {
                <li>
                  <a
                    tabindex="0"
                    class="label-small text-blue-500 dark:blue-red-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-blue-500/10 transition-colors duration-150 cursor-pointer"
                    (click)="changeAccount()"
                    (keydown.enter)="changeAccount()"
                  >
                    <i class="pi pi-arrow-right-arrow-left"></i>
                    <span>{{ 'header.profileMenu.changeAccount' | transloco }}</span>
                  </a>
                </li>
              }
              <li>
                <a
                  tabindex="0"
                  class="label-small text-red-500 dark:text-red-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-red-500/10 transition-colors duration-150 cursor-pointer"
                  (click)="logout()"
                  (keydown.enter)="logout()"
                >
                  <i class="pi pi-power-off"></i>
                  <span>{{ 'header.profileMenu.logout' | transloco }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      }
    </div>
  </div>
</header>

@defer (when isMenuOpen) {
  <p-drawer
    [(visible)]="isMenuOpen"
    [closable]="true"
    [position]="'left'"
    [modal]="true"
    [showCloseIcon]="true"
    [blockScroll]="true"
    [style]="{ width: '320px' }"
  >
    <!-- Header with logo -->
    <ng-template #header>
      <div
        class="flex items-center justify-center gap-4 w-full py-4 border-b border-gray-200 dark:border-gray-700"
      >
        <img src="./icons/logo-d2d.svg" alt="Logo D2D" class="w-14 h-14" aria-hidden="true" />
      </div>
    </ng-template>

    <!-- Main Content -->
    <div class="flex flex-col gap-2 px-4 py-4 overflow-y-auto h-full">
      <!-- Tracking Search Button -->
      <button
        (click)="goToTracking()"
        (keydown.enter)="goToTracking()"
        class="relative flex items-center justify-between gap-2 px-4 py-3 rounded-xl shadow-sm transition-all duration-300 w-full bg-white dark:bg-gray-800 backdrop-blur-md border border-gray-200 dark:border-gray-700 mb-4 hover:border-primary-500 hover:shadow-md group"
        [attr.aria-label]="'header.trackingButtonAria' | transloco"
      >
        <div class="flex items-center gap-3">
          <i
            class="pi pi-search text-gray-400 dark:text-gray-500 text-base group-hover:text-primary-500 transition-colors"
            aria-hidden="true"
          ></i>
          <span class="text-sm text-gray-500 dark:text-gray-400 font-normal">
            {{ 'header.trackingButton' | transloco }}
          </span>
        </div>

        <div class="flex items-center gap-2 text-primary-600 font-medium text-sm">
          <span class="hidden sm:inline">{{ 'header.goLabel' | transloco }}</span>
          <i class="pi pi-arrow-right text-xs" aria-hidden="true"></i>
        </div>
      </button>

      <p-divider class="my-2" />

      <!-- Account Section -->
      <ul class="space-y-1">
        @if (sessionState() === 'loading') {
          <li class="px-3 py-2">
            <p-skeleton width="100%" height="40px" borderRadius="8px" class="mb-2" />
            <p-skeleton width="60%" height="20px" borderRadius="4px" />
          </li>
        } @else if (sessionState() === 'unauthenticated' && !authStore.isGuestFlow()) {
          <li class="px-2 py-1">
            <h3
              class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1"
            >
              {{ 'sidebar.accountSectionTitle' | transloco }}
            </h3>
          </li>

          <li>
            <a
              [routerLink]="['/auth/login']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-sign-in text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.login' | transloco }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/auth/register']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-user-plus text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.register' | transloco }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/auth/forgot-password']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-question-circle text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.forgotPassword' | transloco }}</span>
            </a>
          </li>
        } @else if (sessionState() === 'unauthenticated' && authStore.isGuestFlow()) {
          <!-- Guest flow: opciones de cuenta ocultas intencionalmente -->
        } @else {
          <li class="px-2 py-1">
            <h3
              class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1"
            >
              {{ 'sidebar.myAccountSectionTitle' | transloco }}
            </h3>
          </li>

          @if (account()?.roles?.length) {
            <li>
              <button
                (click)="goToAdmin()"
                (keydown.enter)="goToAdmin()"
                class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50 text-left"
                role="menuitem"
              >
                <i
                  class="pi pi-shield text-base w-5 text-primary-600 dark:text-primary-400"
                  aria-hidden="true"
                ></i>
                <span class="text-sm font-medium">{{ 'sidebar.internalArea' | transloco }}</span>
              </button>
            </li>
          }

          <li>
            <a
              [routerLink]="['/user/profile']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-user text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.myProfile' | transloco }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/user/shipments']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-send text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.myShipments' | transloco }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/user/incidents']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-ticket text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.myIncidents' | transloco }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="['user/addresses']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-globe text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.myAddresses' | transloco }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/user/contacts']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-address-book text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.myContacts' | transloco }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="[`/user/billing`]"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-file text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.myInvoices' | transloco }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/user/settings']"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
              role="menuitem"
            >
              <i
                class="pi pi-cog text-base w-5 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              ></i>
              <span class="text-sm font-medium">{{ 'sidebar.settings' | transloco }}</span>
            </a>
          </li>

          @if (hasAccounts) {
            <li>
              <button
                (click)="changeAccount()"
                (keydown.enter)="changeAccount()"
                class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50 text-left"
                role="menuitem"
              >
                <i
                  class="pi pi-sync text-base w-5 text-primary-600 dark:text-primary-400"
                  aria-hidden="true"
                ></i>
                <span class="text-sm font-medium">{{ 'sidebar.changeAccount' | transloco }}</span>
              </button>
            </li>
          }

          <li>
            <button
              (click)="logout()"
              (keydown.enter)="logout()"
              class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 text-left"
              role="menuitem"
            >
              <i class="pi pi-sign-out text-base w-5" aria-hidden="true"></i>
              <span class="text-sm font-medium">{{ 'sidebar.logout' | transloco }}</span>
            </button>
          </li>
        }
      </ul>
    </div>

    <!-- TODO: hacer que este footer sea un componente reutilizable -->

    <ng-template #footer>
      <div
        class="px-4 py-3 border-t border-surface-200 dark:border-surface-700 flex flex-col items-center gap-3"
      >
        <!-- Botón único: alterna claro/oscuro -->
        <button
          pButton
          type="button"
          class="w-full max-w-xs"
          (click)="toggleDarkMode()"
          (keydown.enter)="toggleDarkMode()"
          pButtonLabel="isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'"
          pButtonIcon="isDark ? 'pi pi-sun' : 'pi pi-moon'"
          [severity]="'secondary'"
          [attr.aria-label]="'header.themeToggleAria' | transloco"
          disabled
        ></button>

        <!-- Selector Dorado / Oliva debajo del botón -->
        <div class="flex flex-col items-center w-full">
          <span class="text-xs text-muted-color mb-1">{{
            'header.primaryColorLabel' | transloco
          }}</span>

          <!-- Contenedor centrado -->
          <div class="flex justify-center w-full">
            <p-selectButton
              class="w-52 justify-center"
              [options]="colorOptions"
              [(ngModel)]="selectedColor"
              optionLabel="name"
              optionValue="value"
              [allowEmpty]="false"
              [unselectable]="false"
              [attr.aria-label]="'header.primaryColorAria' | transloco"
              (onChange)="updateColors('primary', $event.value)"
            >
              <ng-template pTemplate="item" let-option>
                <div class="flex items-center gap-2 justify-center w-full">
                  <span
                    class="inline-block w-3.5 h-3.5 rounded-full border border-black/10"
                    [style.backgroundColor]="option.color"
                  ></span>
                  <span class="text-xs">{{ option.name }}</span>
                </div>
              </ng-template>
            </p-selectButton>
          </div>
        </div>
      </div>
    </ng-template>
  </p-drawer>
}
